import HeadsetInterface from 'resources/headsets/headset-interface';
import { electronActions } from 'flow/utils/electron-utils';
import { addHeadsetLogEntry } from 'flow/utils/browser-utils';

import isElectron from 'is-electron';
import { hashCodeFromString } from 'flow/utils';

const ipcRenderer = isElectron() ? require('electron').ipcRenderer : null;
export default class YealinkHeadset extends HeadsetInterface {
    attachCallbacks = (callbacks) => {
        this.callbacks = callbacks(this.id);
        const deviceId = this.deviceInfo.deviceId;

        electronActions.setupYealinkDevice(deviceId);

        ipcRenderer.on('yealink:hsAnswer', this.callbacks.onAcceptCall);
        ipcRenderer.on('yealink:hsHangup', this.callbacks.onHangup);
        ipcRenderer.on('yealink:hsMute', this.callbacks.onMuteEvent);
        ipcRenderer.on('yealink:hsUnmute', this.callbacks.onUnmuteEvent);
        ipcRenderer.on('yealink:hsHold', this.callbacks.onHoldCall);
        ipcRenderer.on('yealink:hsUnhold', this.callbacks.onUnholdCall);
        ipcRenderer.on('yealink:hsDisconnect', this.callbacks.onDisconnect);

        return this;
    };

    removeHeadsetListeners = () => {
        ipcRenderer.removeAllListeners('yealink:hsAnswer');
        ipcRenderer.removeAllListeners('yealink:hsHangup');
        ipcRenderer.removeAllListeners('yealink:hsMute');
        ipcRenderer.removeAllListeners('yealink:hsUnmute');
        ipcRenderer.removeAllListeners('yealink:hsHold');
        ipcRenderer.removeAllListeners('yealink:hsUnhold');
        ipcRenderer.removeAllListeners('yealink:hsDisconnect');
    };

    async incomingCallImpl(callId) {
        addHeadsetLogEntry('Yealink:signalIncomingCall');
        ipcRenderer.send('yealink:incomingCall', hashCodeFromString(callId));
    }

    async outgoingCallImpl(callId) {
        addHeadsetLogEntry('Yealink:startCall');
        ipcRenderer.send('yealink:outgoingCall', hashCodeFromString(callId));
    }

    async confirmCallImpl(callId) {
        addHeadsetLogEntry('Yealink:confirmCall');
        ipcRenderer.send('yealink:answerCall', hashCodeFromString(callId));
    }

    async endCallImpl(callId) {
        addHeadsetLogEntry('Yealink:endCall');
        ipcRenderer.send('yealink:hangupCall', hashCodeFromString(callId));
    }

    async holdCallImpl(callId) {
        addHeadsetLogEntry('Yealink:hold');
        ipcRenderer.send('yealink:holdCall', hashCodeFromString(callId));
    }

    async resumeCallImpl(callId) {
        addHeadsetLogEntry('Yealink:resume');
        ipcRenderer.send('yealink:resumeCall', hashCodeFromString(callId));
    }

    async muteCallImpl(callId) {
        addHeadsetLogEntry('Yealink:mute');
        ipcRenderer.send('yealink:muteCall', hashCodeFromString(callId));
    }

    unmuteCallImpl(callId) {
        addHeadsetLogEntry('Yealink:unmute');
        ipcRenderer.send('yealink:unmuteCall', hashCodeFromString(callId));
    }

    onDisconnectImpl() {
        this.removeHeadsetListeners();
        ipcRenderer.send('yealink:disconnectDevice');
    }
}
